import { jsPDF } from "jspdf";

export function exportScanPDF(result) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  let y = 0;

  // Header band
  doc.setFillColor(5, 5, 5);
  doc.rect(0, 0, W, 90, "F");
  doc.setTextColor(0, 255, 65);
  doc.setFont("courier", "bold");
  doc.setFontSize(22);
  doc.text("PLYX CYBER GUARD", 40, 48);
  doc.setFontSize(10);
  doc.setTextColor(160, 160, 160);
  doc.setFont("courier", "normal");
  doc.text("SECURITY SCAN REPORT", 40, 68);
  doc.text(new Date().toLocaleString(), W - 40, 68, { align: "right" });

  y = 130;
  doc.setTextColor(20, 20, 20);
  doc.setFont("courier", "bold");
  doc.setFontSize(13);
  doc.text("Scan Summary", 40, y);
  y += 24;

  const rows = [
    ["Scan type", (result.scan_type || "").toUpperCase()],
    ["Target", result.target || "This Device"],
    ["Items scanned", (result.files_scanned || 0).toLocaleString()],
    ["Threats found", String(result.threats_found || 0)],
    ["Security score", `${result.score}/100`],
    ["Status", result.threats_found > 0 ? "THREATS NEUTRALIZED" : "SYSTEM CLEAN"],
  ];
  doc.setFontSize(11);
  rows.forEach(([k, v]) => {
    doc.setFont("courier", "normal");
    doc.setTextColor(110, 110, 110);
    doc.text(k, 40, y);
    doc.setFont("courier", "bold");
    doc.setTextColor(20, 20, 20);
    doc.text(String(v), 220, y);
    y += 22;
  });

  y += 14;
  doc.setDrawColor(220, 220, 220);
  doc.line(40, y, W - 40, y);
  y += 26;

  doc.setFont("courier", "bold");
  doc.setFontSize(13);
  doc.setTextColor(20, 20, 20);
  doc.text("Findings", 40, y);
  y += 24;

  if (!result.findings || result.findings.length === 0) {
    doc.setFont("courier", "normal");
    doc.setFontSize(11);
    doc.setTextColor(0, 150, 40);
    doc.text("No threats detected. Your system is clean.", 40, y);
  } else {
    result.findings.forEach((f, i) => {
      if (y > 760) { doc.addPage(); y = 60; }
      doc.setFont("courier", "bold");
      doc.setFontSize(11);
      doc.setTextColor(200, 0, 50);
      doc.text(`[${f.severity.toUpperCase()}] ${f.name}`, 40, y);
      y += 16;
      doc.setFont("courier", "normal");
      doc.setFontSize(9);
      doc.setTextColor(90, 90, 90);
      doc.text(`Type: ${f.type}  |  Location: ${f.location}  |  Quarantined`, 40, y);
      y += 14;
      const lines = doc.splitTextToSize(f.detail, W - 80);
      doc.setTextColor(50, 50, 50);
      doc.text(lines, 40, y);
      y += lines.length * 12 + 14;
    });
  }

  doc.setFont("courier", "normal");
  doc.setFontSize(8);
  doc.setTextColor(150, 150, 150);
  doc.text("Generated by Plyx Cyber Guard · confidential", 40, 810);

  doc.save(`plyx-scan-${result.scan_type}-${Date.now()}.pdf`);
}
